"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Generated API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InstantJobsApi = exports.InstantJobsApiFactory = exports.InstantJobsApiFp = exports.InstantJobsApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * InstantJobsApi - axios parameter creator
 * @export
 */
const InstantJobsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {InstantJobConfig} [instantJobConfig]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instantJobsResourceCreateInstantJob: (instantJobConfig_1, ...args_1) => __awaiter(this, [instantJobConfig_1, ...args_1], void 0, function* (instantJobConfig, options = {}) {
            const localVarPath = `/instant-jobs/enqueue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(instantJobConfig, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} jobId
         * @param {PythonTaskData} [pythonTaskData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instantJobsResourceFinishJobCallback: (jobId_1, pythonTaskData_1, ...args_2) => __awaiter(this, [jobId_1, pythonTaskData_1, ...args_2], void 0, function* (jobId, pythonTaskData, options = {}) {
            // verify required parameter 'jobId' is not null or undefined
            (0, common_1.assertParamExists)('instantJobsResourceFinishJobCallback', 'jobId', jobId);
            const localVarPath = `/instant-jobs/{jobId}/finish-callback`
                .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(pythonTaskData, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instantJobsResourceGetAllJobStatuses: (...args_3) => __awaiter(this, [...args_3], void 0, function* (options = {}) {
            const localVarPath = `/instant-jobs/statuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} jobId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instantJobsResourceGetInstantJob: (jobId_2, ...args_4) => __awaiter(this, [jobId_2, ...args_4], void 0, function* (jobId, options = {}) {
            // verify required parameter 'jobId' is not null or undefined
            (0, common_1.assertParamExists)('instantJobsResourceGetInstantJob', 'jobId', jobId);
            const localVarPath = `/instant-jobs/{jobId}/status`
                .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} jobId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instantJobsResourceGetTaskData: (jobId_3, ...args_5) => __awaiter(this, [jobId_3, ...args_5], void 0, function* (jobId, options = {}) {
            // verify required parameter 'jobId' is not null or undefined
            (0, common_1.assertParamExists)('instantJobsResourceGetTaskData', 'jobId', jobId);
            const localVarPath = `/instant-jobs/{jobId}/data`
                .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} jobId
         * @param {InstantJobConfig} [instantJobConfig]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instantJobsResourceGetTaskDataCallback: (jobId_4, instantJobConfig_2, ...args_6) => __awaiter(this, [jobId_4, instantJobConfig_2, ...args_6], void 0, function* (jobId, instantJobConfig, options = {}) {
            // verify required parameter 'jobId' is not null or undefined
            (0, common_1.assertParamExists)('instantJobsResourceGetTaskDataCallback', 'jobId', jobId);
            const localVarPath = `/instant-jobs/{jobId}/data-callback`
                .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(instantJobConfig, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} jobId
         * @param {InstantJobStatusCallbackRequest} [instantJobStatusCallbackRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instantJobsResourceInstantJobLogCallback: (jobId_5, instantJobStatusCallbackRequest_1, ...args_7) => __awaiter(this, [jobId_5, instantJobStatusCallbackRequest_1, ...args_7], void 0, function* (jobId, instantJobStatusCallbackRequest, options = {}) {
            // verify required parameter 'jobId' is not null or undefined
            (0, common_1.assertParamExists)('instantJobsResourceInstantJobLogCallback', 'jobId', jobId);
            const localVarPath = `/instant-jobs/{jobId}/status-callback`
                .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(instantJobStatusCallbackRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.InstantJobsApiAxiosParamCreator = InstantJobsApiAxiosParamCreator;
/**
 * InstantJobsApi - functional programming interface
 * @export
 */
const InstantJobsApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.InstantJobsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {InstantJobConfig} [instantJobConfig]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instantJobsResourceCreateInstantJob(instantJobConfig, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.instantJobsResourceCreateInstantJob(instantJobConfig, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['InstantJobsApi.instantJobsResourceCreateInstantJob']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} jobId
         * @param {PythonTaskData} [pythonTaskData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instantJobsResourceFinishJobCallback(jobId, pythonTaskData, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.instantJobsResourceFinishJobCallback(jobId, pythonTaskData, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['InstantJobsApi.instantJobsResourceFinishJobCallback']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instantJobsResourceGetAllJobStatuses(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.instantJobsResourceGetAllJobStatuses(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['InstantJobsApi.instantJobsResourceGetAllJobStatuses']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} jobId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instantJobsResourceGetInstantJob(jobId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.instantJobsResourceGetInstantJob(jobId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['InstantJobsApi.instantJobsResourceGetInstantJob']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} jobId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instantJobsResourceGetTaskData(jobId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.instantJobsResourceGetTaskData(jobId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['InstantJobsApi.instantJobsResourceGetTaskData']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} jobId
         * @param {InstantJobConfig} [instantJobConfig]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instantJobsResourceGetTaskDataCallback(jobId, instantJobConfig, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.instantJobsResourceGetTaskDataCallback(jobId, instantJobConfig, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['InstantJobsApi.instantJobsResourceGetTaskDataCallback']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {string} jobId
         * @param {InstantJobStatusCallbackRequest} [instantJobStatusCallbackRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instantJobsResourceInstantJobLogCallback(jobId, instantJobStatusCallbackRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.instantJobsResourceInstantJobLogCallback(jobId, instantJobStatusCallbackRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['InstantJobsApi.instantJobsResourceInstantJobLogCallback']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.InstantJobsApiFp = InstantJobsApiFp;
/**
 * InstantJobsApi - factory interface
 * @export
 */
const InstantJobsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.InstantJobsApiFp)(configuration);
    return {
        /**
         *
         * @param {InstantJobsApiInstantJobsResourceCreateInstantJobRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instantJobsResourceCreateInstantJob(requestParameters = {}, options) {
            return localVarFp.instantJobsResourceCreateInstantJob(requestParameters.instantJobConfig, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {InstantJobsApiInstantJobsResourceFinishJobCallbackRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instantJobsResourceFinishJobCallback(requestParameters, options) {
            return localVarFp.instantJobsResourceFinishJobCallback(requestParameters.jobId, requestParameters.pythonTaskData, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instantJobsResourceGetAllJobStatuses(options) {
            return localVarFp.instantJobsResourceGetAllJobStatuses(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {InstantJobsApiInstantJobsResourceGetInstantJobRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instantJobsResourceGetInstantJob(requestParameters, options) {
            return localVarFp.instantJobsResourceGetInstantJob(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {InstantJobsApiInstantJobsResourceGetTaskDataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instantJobsResourceGetTaskData(requestParameters, options) {
            return localVarFp.instantJobsResourceGetTaskData(requestParameters.jobId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {InstantJobsApiInstantJobsResourceGetTaskDataCallbackRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instantJobsResourceGetTaskDataCallback(requestParameters, options) {
            return localVarFp.instantJobsResourceGetTaskDataCallback(requestParameters.jobId, requestParameters.instantJobConfig, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {InstantJobsApiInstantJobsResourceInstantJobLogCallbackRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instantJobsResourceInstantJobLogCallback(requestParameters, options) {
            return localVarFp.instantJobsResourceInstantJobLogCallback(requestParameters.jobId, requestParameters.instantJobStatusCallbackRequest, options).then((request) => request(axios, basePath));
        },
    };
};
exports.InstantJobsApiFactory = InstantJobsApiFactory;
/**
 * InstantJobsApi - object-oriented interface
 * @export
 * @class InstantJobsApi
 * @extends {BaseAPI}
 */
class InstantJobsApi extends base_1.BaseAPI {
    /**
     *
     * @param {InstantJobsApiInstantJobsResourceCreateInstantJobRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstantJobsApi
     */
    instantJobsResourceCreateInstantJob(requestParameters = {}, options) {
        return (0, exports.InstantJobsApiFp)(this.configuration).instantJobsResourceCreateInstantJob(requestParameters.instantJobConfig, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {InstantJobsApiInstantJobsResourceFinishJobCallbackRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstantJobsApi
     */
    instantJobsResourceFinishJobCallback(requestParameters, options) {
        return (0, exports.InstantJobsApiFp)(this.configuration).instantJobsResourceFinishJobCallback(requestParameters.jobId, requestParameters.pythonTaskData, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstantJobsApi
     */
    instantJobsResourceGetAllJobStatuses(options) {
        return (0, exports.InstantJobsApiFp)(this.configuration).instantJobsResourceGetAllJobStatuses(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {InstantJobsApiInstantJobsResourceGetInstantJobRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstantJobsApi
     */
    instantJobsResourceGetInstantJob(requestParameters, options) {
        return (0, exports.InstantJobsApiFp)(this.configuration).instantJobsResourceGetInstantJob(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {InstantJobsApiInstantJobsResourceGetTaskDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstantJobsApi
     */
    instantJobsResourceGetTaskData(requestParameters, options) {
        return (0, exports.InstantJobsApiFp)(this.configuration).instantJobsResourceGetTaskData(requestParameters.jobId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {InstantJobsApiInstantJobsResourceGetTaskDataCallbackRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstantJobsApi
     */
    instantJobsResourceGetTaskDataCallback(requestParameters, options) {
        return (0, exports.InstantJobsApiFp)(this.configuration).instantJobsResourceGetTaskDataCallback(requestParameters.jobId, requestParameters.instantJobConfig, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {InstantJobsApiInstantJobsResourceInstantJobLogCallbackRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstantJobsApi
     */
    instantJobsResourceInstantJobLogCallback(requestParameters, options) {
        return (0, exports.InstantJobsApiFp)(this.configuration).instantJobsResourceInstantJobLogCallback(requestParameters.jobId, requestParameters.instantJobStatusCallbackRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.InstantJobsApi = InstantJobsApi;
//# sourceMappingURL=instant-jobs-api.js.map